import { network } from './network';

export async function getNotifyList(opts) {
	const res = await network({
		url: `/api/v1/app/notify_list`,
		method: 'post',
		params: {},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function updateReadNotifyStatus(opts) {
	const res = await network({
		url: `/api/v1/app/notify_read`,
		method: 'post',
		params: {},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

